import { useEffect, useRef } from "react";

export default function useAccessibleFocus(isShow = true, inputRef = null) {
  const ref = inputRef || useRef(null);

  useEffect(() => {
    if (ref.current && isShow) {
      ref.current.focus();
    }
  }, [isShow]);

  return ref;
}